import { cloneDeep, defaultsDeep } from 'lodash'

import { EMPTY_SENDERNAMES, PUBLIC_FIELDS_USER } from '@sigma-legacy-libs/essentials/lib/constants'

import { SENDERNAMES_FILTER, fillDependence, serviceTemplate, services } from '@/utils'

import { errorProcessorHandler } from '@/components/services/sendernames/utils'

export default {
  mixins: [
    serviceTemplate({
      serviceName: services.sendernames,

      async inputFilter(result) {
        if (!result.Owner) {
          await fillDependence.call(this, result, {
            service: 'users',
            permissions: [ 'reseller', true ],
            pathToId: 'OwnerId',
            pathToObject: 'Owner',
            outputPath: 'Owner',
            picks: PUBLIC_FIELDS_USER
          })
        }

        result.OwnerId = result.Owner && result.Owner.id || result.OwnerId

        return defaultsDeep(result, EMPTY_SENDERNAMES)
      },

      find: {
        defaultFilter: cloneDeep(SENDERNAMES_FILTER),
        defaultOrder: { updatedAt: 'desc' }
      },

      width: 440,
      titlePath: 'name',

      has: {
        clone: false,
        source: true
      },

      formClass: '',
      errorProcessor: errorProcessorHandler,

      mounted() {
        if (this.checkPermissions(`advanced.${services.sendernames}.get`, 'me')) {
          this.restData[services.sendernames].find.filter.$scope = [ 'full', 'attached' ]
        }
      }
    })
  ]
}
